import useSWR from 'swr';
import type { Policy } from '@mls-wallet/shared-types';
import denApi from '@/lib/api/denApi';

/**
 * Fetcher function to get policies from the API
 */
const fetcher = async (url: string): Promise<Policy[]> => {
  return await denApi.get<Policy[]>(url);
};

/**
 * Hook to list all policies for an organization
 */
export function useListPolicies(organizationId: string) {
  const { data, error, isLoading, mutate } = useSWR<Policy[]>(
    // Org context comes from x-current-org-id cookie (not URL params)
    organizationId ? `policy` : null,
    fetcher,
    {
      refreshInterval: 10000, // Refresh every 10 seconds
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    policies: data,
    isLoading,
    error,
    mutate,
    // Alias for consistency with other hooks
    loadPolicies: mutate,
  };
}
